import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService } from 'tms-lib';
import { MagentoProduct } from '../../models';
import { TmsWebBaseService } from '../base/tms-web-base.service';

@Injectable({
  providedIn: 'root',
})
export class ProductMagentoService extends TmsWebBaseService {
  constructor(protected httpService: HttpService) {
    super('ProductMagento', httpService);
  }

  getProduct(): Observable<MagentoProduct[]> {
    return this.httpService.get<MagentoProduct[]>(`${this.apiUrl}/GetProducts`);
  }

  getImportProducts(): Observable<MagentoProduct[]> {
    return this.httpService.post<MagentoProduct[]>(`${this.apiUrl}/ImportProductStock`, {});
  }

  getMagentoProductLink(): Observable<any> {
    return this.httpService.post<any>(`${this.apiUrl}/UpdateMagentoProductLink`, {});
  }
}
